__webpack_require__.p = "/mohsin-portfolio/";